<template>
  <div class="px-4 py-2">
    <div>
      <div>
        <p v-if="showDetails" class="mb-0">
          <span class="caption">
              {{
                isConflictOnSameScenario ?
                $t('conflict.conflictOnScenario', { scenario: conflict.combinedScenarios[0] })
                : $t('conflict.conflictBetweenScenarios', { scenarios: conflict.combinedScenarios.join(', ')})
              }}
          </span>
        </p>
        <v-chip
          v-if="conflictResolved"
          color="success"
          small
          class="mb-2"
        >
          {{ $t('conflict.solved') }} <v-icon>mdi-check</v-icon>
        </v-chip>
        <v-chip
            v-else-if="conflictHasWorkInProgress"
            color="orange"
            small
            class="mb-2"
          >
          {{ $t('conflict40.workInProgress') }} <v-icon>mdi-progress-check</v-icon>
        </v-chip>
    </div>
  </div>
  <div>
    <elements
      :scenario="conflict.scenario"
    />
  </div>
</div>
</template>
<script>
import Elements from '@/components/global/Elements'

import conflictService from '@/services/conflicts'

export default {
  name: 'Conflict',

  components: {
    Elements,
  },

  mixins: [],

  data () {
    return {}
  },

  props: {
    conflict: {
      type: Object,
      required: true
    },
    showDetails: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    conflictResolved() {
      return conflictService.isConflictResolved(this.conflict)
    },
    conflictHasWorkInProgress() {
      return conflictService.hasConflictWorkInProgress(this.conflict)
    },
    isConflictOnSameScenario() {
      return conflictService.isConflictOnSameScenario(this.conflict)
    }
  },

  methods: {
  }
}
</script>
<style>

</style>
